import React from 'react';
import styled from 'styled-components/macro';
import { Span } from '../../../../../typography';
import { Col } from '../../../../../grid';

export const InfoTitle = styled(Span)`
  font-weight: bold;
  display: inline;
  margin-right: 10px;

  @media (max-width: 1199px) {
    display: block;
    margin-right: 0px;
  }
`;

const InfoColNoStyle = ({ ...props }) => <Col xs={6} md={3} lg={6} {...props} />;

export const InfoCol = styled(InfoColNoStyle)`
  padding-top: 0px;
  padding-bottom: 0px;

  @media (max-width: 991px) {
    padding-bottom: 15px;
  }
`;

export const InfoDiv = styled.div`
  line-height: 1.5em;
  margin-top: 15px;
`;
